import { lazy } from 'react'

export const IntegrationRoutesLazy = lazy(() => import('./Integration'))
